import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'myDisplayNullPipe'})
export class DisplayNullPipe implements PipeTransform {

  private static returnCorrectFormat(object: any) {
    return (object) ? object : '-';
  }

  public transform(value: any, fieldName: string = ''): any {
    // Case 1: test value param
    if (!fieldName) {
      return DisplayNullPipe.returnCorrectFormat(value);
    } else {
      // Case 2: test sub attribut value
      return (value) ? DisplayNullPipe.returnCorrectFormat(value[fieldName]) : '-';
    }
  }
}
